export default "__VITE_ASSET__pwxxrc44__"